import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import { CircularProgress } from "@material-ui/core";
import { Popup } from "@progress/kendo-react-popup";
import { toastr } from "react-redux-toastr";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Checkbox } from "@progress/kendo-react-inputs";
import { filterBy } from "@progress/kendo-data-query";
import RiskDescriptionCell from "./RiskDescriptionCell";
import Api from "../../../Services/Api";
import StatusComponent from "./StatusComponent";
import { CopyExpandActionDetails } from "../../Dashboard/CopyExpandActionDetails";

export default class CopyRiskAndAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workStreamList: [],
      loader: false,
      includeAction: false,
      riskList: [],
      filter: [],
      selectedIds: [],
      take: 5,
      skip: 0,
      flag: true,
    };
    this.expandChange = this.expandChange.bind(this);
  }

  componentDidUpdate = () => {
    if (this.props.copyRiskAndActionFlag && this.state.flag) {
      this.getOrganizationsUnits();
    }
  };
  
  getOrganizationsUnits = async () => {
    try {
      this.setState({ ...this.state, flag: false, loader: true,riskList:[]});
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getAllWorkstream(request);
      if (response.status === 200) {
        let filteredData=response.organisationUnit.filter((item)=>item.unitId!=parseInt(this.props.orgUnitId));
        this.setState({
          ...this.state,
          workStreamList: filteredData,
          loader: false,
        });
      } else {
        this.setState({ ...this.state, workStreamList: [], loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  saveSelectedIds = (data) => {
    let listOfIds = [];
    for (let row of Object.values(data)) {
      if (row.selected) {
        listOfIds.push(row.riskRegisterId);
      }
    }
    this.setState({ selectedIds: listOfIds }, () =>
      console.log(this.state.selectedIds)
    );
  };
  headerSelectionChange = (event) => {
    const checked = event.syntheticEvent.target.checked;
    const data = this.state.riskList.map((item) => {
      item.selected = checked;
      return item;
    });
    this.saveSelectedIds(data);
    this.setState({ data });
  };
  expandChange(event) {
    event.dataItem.expanded = event.value;
    let riskRegisterId = event.dataItem.riskRegisterId;
    this.setState({ ...this.state });
    if (!event.value || event.dataItem.mitigationResps) {
      return;
    }
    let data = this.state.riskList.slice();
    let index = data.findIndex((d) => d.riskRegisterId === riskRegisterId);
    data[index].mitigationResps = this.state.riskList.filter(
      (d) => d.riskRegisterId === riskRegisterId
    );
    this.setState({ riskList: data });
  }
  dataStateChange = (event) => {
    this.setState(this.createAppState(event.dataState));
  };

  selectionChange = (event) => {
    const data = this.state.riskList.map((item) => {
      if (item.riskRegisterId === event.dataItem.riskRegisterId) {
        item.selected = !event.dataItem.selected;
      }
      return item;
    });
    this.saveSelectedIds(data);
    this.setState({ data });
  };
  createAppState = (dataState) => {
    if (this.state && this.state.riskTemp) {
      return {
        riskList: this.state.riskTemp.slice(0),
        dataState: dataState,
      };
    } else {
      return {
        riskList: [],
        dataState: dataState,
      };
    }
  };
  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };


  getRiskListByOrgUnitIds = async (ws) => {
    try {
      this.setState({
        ...this.state,
        loader: true,
      });
      var request = {
        OrgUnitIds: [ws.value.unitId],
      };

      let response = await Api.getRiskForOrgUnit(request);
      if (response.status === 200) {
        var riskData = response.riskRegister.map((dataItem) =>
          Object.assign({ selected: false }, dataItem)
        );
        this.setState({
          ...this.state,
          riskList: riskData,
          loader: false,
        });
        this.saveSelectedIds(riskData);
      } else {
        this.setState({
          ...this.state,
          riskList: [],
          loader: false,
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        ...this.state,
        loader: false,
      });
    }
  };

  onSubmit =async () => {
   
    try {
      this.setState({
        ...this.state,
        loader: true,
      });
      var request = {
        "OrganizationUnitId" : parseInt(this.props.orgUnitId),
        "RiskIds" : this.state.selectedIds,
        "CreatedBy" :parseInt(secureLocalStorage.getItem("loginUserId")),
        "IsActionEnabled": this.state.includeAction
        }

      let response = await Api.copyRisks(request);
      if (response.status === 200) {
        toastr.success(response.message);
        this.cancel();
        this.props.getRiskRegistorList();
    } else {
      this.setState({ ...this.state, loader: false });
      toastr.error(response.message);
    }
    } catch (error) {
      console.error(error);
      this.setState({
        ...this.state,
        loader: false,
      });
    }
  };

  cancel=()=>{
    this.setState({
      ...this.state,
      riskList: [],
      selectedIds:[],
      loader:false,
      take: 5,
      skip: 0,
      includeAction: false
    });
    this.props.closeCopyRiskAndActionPopup();
  }
  enterEdit = () => {};

  render() {
    const riskList=this.state.riskList?this.state.riskList:[];
    return (
      <>
        <Popup
          show={this.props.copyRiskAndActionFlag}
          popupClass={"popup-content"}
        >
          <div className="createDashboardDialog copyRiskContainer" style={{ width: "50%" }}>
            <h4 className="copyRisk">Copy Risk/Action</h4>
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="row">
              <div className="col-sm-3 col-md-12">
                <label className="copyRisk">Select Workstream :&nbsp;</label>
                <DropDownList
                className="selectWs"
                  data={this.state.workStreamList}
                  textField="name"
                  onChange={(e) => this.getRiskListByOrgUnitIds(e)}
                />
              </div>
            </div>
            <br></br>
            <div className="accessSpecifier copyRisk">
              <Checkbox
                // defaultValue={this.state.includeAction}
                label={"Include Actions"}
                onChange={(e) => {
                  this.setState({
                    ...this.state,
                    includeAction: e.value,
                  });
                }}
              />
            </div>
            <br></br>
            <div className="dataGrids">
              <Grid
                style={{ minHeight: "100px" }}
                data={filterBy(riskList, this.state.filter).slice(
                  this.state.skip,
                  this.state.take + this.state.skip
                )}
                reorderable
                resizable
                expandField="expanded"
                onExpandChange={this.expandChange}
                detail={CopyExpandActionDetails}
                {...this.state.dataState}
                onDataStateChange={this.dataStateChange}
                selectedField="selected"
                onSelectionChange={this.selectionChange}
                onHeaderSelectionChange={this.headerSelectionChange}
                pageable={true}
                sortable={{
                  allowUnsort: true,
                  mode: "multiple",
                }}
                total={filterBy(riskList, this.state.filter).length}
                skip={this.state.skip}
                take={this.state.take}
                onPageChange={this.pageChange}
              >
                <Column
                  field="selected"
                  width="42px"
                  headerSelectionValue={
                    riskList.findIndex(
                      (dataItem) => dataItem.selected === false
                    ) === -1
                  }
                />
                <Column field="number" title="Risk Number" width="80px" />
                <Column field="riskTitle" title="Risk Title*" width="150px" />
                <Column
                  field="isOpportunity"
                  title="T/O *"
                  width="80px"
                  cell={(props) => (
                    props.dataItem.isOpportunity==="Threat"?
                    (
                      <td >{props.dataItem.isOpportunity}</td>
                    ):(
                      <td><span className="turquoiseBlue">{props.dataItem.isOpportunity}</span></td>
                      )
                  )}
                />
                <Column
                  field="name"
                  title="Risk Description"
                  width="150px"
                  editable={false}
                  cell={(props) => (
                    <RiskDescriptionCell
                      {...props}
                      onEditCell={this.enterEdit}
                    />
                  )}
                />
                <Column
                  field="isClosed"
                  title="Status"
                  width="70px"
                  cell={(props) => (
                    <StatusComponent {...props} onEditCell={this.enterEdit} />
                  )}
                />
              </Grid>
            </div>

            <div className="row">
              <div className="col-sm-3 col-md-6"></div>
              <div className="col-sm-3 col-md-6">
                <div className="copyriskandactionBtn">
                  <button
                    className="greenbtn"
                    type="button"
                    onClick={this.onSubmit}
                      disabled={this.state.selectedIds.length===0}
                  >
                    Submit
                  </button>
                  &nbsp;&nbsp;
                  <button
                    onClick={this.cancel}
                    className="redbtn"
                    type="button"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Popup>
      </>
    );
  }
}
